var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-24p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2971_64883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2971_64883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48374 10.6086V17.1436H7.98373V10.6086H6.48374ZM11.2504 10.6086V17.1436H12.7504V10.6086H11.2504ZM3.90039 18.633V20.1H20.1004V18.633H3.90039ZM16.0171 10.6086V17.1436H17.517V10.6086H16.0171ZM3.90039 7.75412V9.11922H20.1004V7.75412L12.0004 3.88916L3.90039 7.75412ZM12.0004 5.42941L16.9271 7.75223H7.07381L7.07379 7.75224H16.9272L12.0005 5.42939L12.0004 5.42941ZM12.0004 5.53994L16.4805 7.65223H7.52028L12.0004 5.53994ZM6.58384 17.0436H6.58374V10.7086H7.88373V10.7086H6.58384V17.0436ZM11.3505 17.0436H11.3504V10.7086H12.6504V10.7086H11.3505V17.0436ZM4.00049 20L4.00039 20V18.733H20.0004L4.00049 18.733V20ZM16.1172 17.0436H16.1171V10.7086H17.417V10.7086H16.1172V17.0436ZM4.00049 9.01922H4.00039V7.81721L12.0004 3.99996L12.0004 3.99999L4.00049 7.81721V9.01922Z",
    fill: "#1460E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.ad3b2738ca352a2d442f15df13c0a444.svg";
export { ForwardRef as ReactComponent };